<template>
    <div id="app">
        <section class="hero is-primary">
            <div class="hero-body">
                <div class="container">
                    <h1 class="title">Pixelated</h1>
                    <h2 class="subtitle">Pixel gradient maker</h2>
                </div>
            </div>
        </section>
        <div class="container is-fluid controls">
            <div class="columns is-multiline">
                <div class="column">
                    <b-field label="Pixel Size">
                        <b-slider v-model="size" :step="sizeStep" :min="sizeMin" :max="sizeMax" @input="fillCanvas" lazy></b-slider>
                    </b-field>
                </div>
                <div class="column">
                    <b-field label="Width">
                        <b-numberinput controls-position="compact" v-model="w" @input="fillCanvas" min="0" :step="canvasSizeStep"></b-numberinput>
                    </b-field>
                </div>
                <div class="column">
                    <b-field label="Height">
                        <b-numberinput controls-position="compact" v-model="h" @input="fillCanvas" min="0" :step="canvasSizeStep"></b-numberinput>
                    </b-field>
                </div>
                <div class="column">
                    <div class="label">Orientation</div>
                    <b-field>
                        <b-radio-button v-model="orientation" @input="drawPixels(tcs, bcs, 'vertical')" native-value="vertical" type="is-primary">
                            <span>Vertical</span>
                        </b-radio-button>

                        <b-radio-button v-model="orientation" @input="drawPixels(tcs, bcs, 'horizontal')" native-value="horizontal" type="is-primary">
                            <span>Horizontal</span>
                        </b-radio-button>
                    </b-field>
                </div>
                <div class="column">
                    <b-field label="Top Color">
                        <b-dropdown aria-role="list" :close-on-click="false">
                            <button class="button is-primary" slot="trigger">
                                <span>Pick me !</span>
                                <b-icon icon="menu-down"></b-icon>
                            </button>

                            <b-dropdown-item aria-role="listitem" :focusable="false" :paddingless="true">
                                <chrome-picker v-model="color" @input="changeColor"></chrome-picker>
                            </b-dropdown-item>
                        </b-dropdown>
                    </b-field>
                    <b-field label="Top Color Start">
                        <b-slider :custom-formatter="val => val * 100 + '%'" v-model="tcs" :step="tcsStep" :min="csMin" :max="csMax" @input="changeColor" lazy></b-slider>
                    </b-field>
                </div>
                <div class="column">
                    <b-field label="Bottom Color">
                        <b-dropdown aria-role="list" :close-on-click="false">
                            <button class="button is-primary" slot="trigger">
                                <span>Pick me !</span>
                                <b-icon icon="menu-down"></b-icon>
                            </button>

                            <b-dropdown-item aria-role="listitem" :focusable="false" :paddingless="true">
                                <chrome-picker v-model="bg" @input="changeColor"></chrome-picker>
                            </b-dropdown-item>
                        </b-dropdown>
                    </b-field>
                    <b-field label="Bottom Color Start">
                        <b-slider :custom-formatter="val => val * 100 + '%'" v-model="bcs" :step="bcsStep" :min="csMin" :max="csMax" @input="changeColor" lazy></b-slider>
                    </b-field>
                </div>
            </div>
        </div>
        <div class="has-text-centered">
            <canvas ref="rect"></canvas>
        </div>
    </div>
</template>

<script>
import shuffle from 'lodash/shuffle';
import debounce from 'lodash/debounce';
import { Chrome } from 'vue-color';
export default {
    name: 'app',
    data() {
        return {
            canvas: null,
            ctx: null,
            size: 10,
            sizeStep: 2,
            sizeMin: 4,
            sizeMax: 100,
            w: 500,
            h: 500,
            canvasSizeStep: 1,
            tcs: 0.1,
            tcsStep: 0.05,
            bcs: 0.85,
            bcsStep: 0.05,
            csMin: 0,
            csMax: 1,
            map: null,
            buildMap: null,
            color: { hex: '#000000' },
            bg: { hex: '#000ff0' },
            orientation: 'vertical'
        };
    },
    components: {
        'chrome-picker': Chrome
    },
    methods: {
        changeColor: debounce(function() {
            this.drawPixels(this.tcs, this.bcs, this.orientation);
        }, 100),
        fillCanvas: function() {
            this.map = [];
            for (let x = 0; x < this.w; x += this.size) {
                for (let y = 0; y < this.h; y += this.size) {
                    this.map.push({ x: x, y: y });
                }
            }
            this.canvas.width = this.w;
            this.canvas.height = this.h;

            this.drawPixels(this.tcs, this.bcs, this.orientation);
        },
        drawPixels: function(tcs, bcs, orientation) {
            for (let i = 0; i < this.map.length; i++) {
                if (this.orientation == 'vertical') {
                    if (this.map[i].y < tcs * this.h) {
                        this.ctx.fillStyle = this.color.hex;
                    } else if (this.map[i].y > bcs * this.h) {
                        this.ctx.fillStyle = this.bg.hex;
                    } else {
                        const localYAbs = (this.map[i].y - tcs * this.h) / (bcs * this.h - tcs * this.h);

                        this.ctx.fillStyle = Math.random() > localYAbs ? this.color.hex : this.bg.hex;
                    }
                } else {
                    if (this.map[i].x < tcs * this.w) {
                        this.ctx.fillStyle = this.color.hex;
                    } else if (this.map[i].x > bcs * this.w) {
                        this.ctx.fillStyle = this.bg.hex;
                    } else {
                        const localYAbs = (this.map[i].x - tcs * this.w) / (bcs * this.w - tcs * this.w);

                        this.ctx.fillStyle = Math.random() > localYAbs ? this.color.hex : this.bg.hex;
                    }
                }

                this.ctx.beginPath();
                this.ctx.rect(this.map[i].x, this.map[i].y, this.size, this.size);
                this.ctx.fill();
            }
        }
    },

    mounted() {
        this.canvas = this.$refs.rect;
        this.ctx = this.canvas.getContext('2d');
    }
};
</script>

<style>
#app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
}
.hero {
    margin-bottom: 60px;
}
canvas {
    margin-top: 60px;
}
.dropdown-content {
    padding: 0;
}
@import '~buefy/dist/buefy.css';
</style>
